<template>
  <Dialog :modelValue="modelValue" @update:modelValue="emit('update:modelValue', $event)" @close="emit('close')">
    <div class="dialog">
      <div v-if="showTitle" class="dialog-title">
        <img :src="rewardTitleImg" alt="rewardTitle">
      </div>
      <div class="dialog-content-wrap" :class="{ 'no-title': !showTitle }">
        <div class="reward-list" :class="{ 'few-rewards': rewards.length <= 2 }">
          <div v-for="(item, index) in rewards" :key="index" class="reward-item">
            <div class="reward-icon-wrap">
              <img class="reward-icon" :src="propIcon(item)" :alt="propName(item.propId)">
            </div>
            <p class="reward-text">{{ propName(item.propId) }} * {{ item.propCount || 1 }}</p>
          </div>
        </div>
        <button type="button" class="reward-ok" @click="emit('update:modelValue', false)">
          {{ t('halloween.rewardConfirm') }}
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../index.vue'
import RewardTitleMap from '@/views/act/halloween/assets/img/rewardTitle'

const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  rewards: {
    type: Array,
    default: () => [],
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:modelValue', 'close'])
const { t, te, locale } = useI18n()

const rewardTitleImg = computed(() => RewardTitleMap[locale.value] || RewardTitleMap.en)

const propName = (propId) => {
  const key = `halloween.props.${propId}`
  return te(key) ? t(key) : propId
}

const propIcon = (item) => `${PUBLIC_PATH}imgs/props/${item?.propId}.png`
</script>

<style scoped lang="less">
.dialog {
  overflow: hidden;

  .dialog-title {
    width: 424px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/dialog-title-bg.png') no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-top: -10px;

    img {
      height: 65px;
      margin-top: 10px;
    }
  }

  .dialog-content-wrap {
    width: 608px;
    height: 420px;
    margin: 16px auto 0;
    padding: 16px 16px 12px;
    box-sizing: border-box;
    // background: url('~@/views/act/halloween/assets/img/dialog-inner-bg.png') no-repeat center center / 100% 100%;
    display: flex;
    flex-direction: column;

    &.no-title {
      margin-top: 48px;
      height: 450px;
    }
  }
}

.reward-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  gap: 16px 8px;

  &.few-rewards {
    gap: 16px 24px;

    .reward-item {
      width: auto;
      max-width: 100%;
      padding: 0 12px;
    }

    .reward-text {
      white-space: nowrap;
      word-break: normal;
    }
  }
}

.reward-item {
  width: 132px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .reward-icon-wrap {
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/prop-bg.png') no-repeat center center / 100% 100%;
  }
}

.reward-icon {
  width: 90px;
  height: 90px;
  object-fit: contain;
}

.reward-text {
  margin: 8px 0 0;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
}

.reward-ok {
  flex: none;
  align-self: center;
  border: 0;
  font-weight: 800;
  cursor: pointer;
  background: url('~@/views/act/halloween/assets/img/reward-ok-bg.png') no-repeat center center / 100% 100%;
  width: 267px;
  height: 83px;
  color: #FFFF76;
  font-size: 32px;
}
</style>
